import * as React from 'react';

import _ from 'lodash';
import { compose } from 'recompose';
import connectToStores from 'vendor/cnpm/fluxible.v0-4/addons/connectToStores';

import type { ActionContext } from 'js/lib/ActionContext';

import { Button, Typography } from '@coursera/cds-core';

import Modal from 'bundles/phoenix/components/Modal';

import _t from 'i18n!nls/staff-management';

import 'css!./__styles__/PaintedDoor';

import { actions } from './store';
import withFluxibleContextAsProps from './withFluxibleContextAsProps';
import withShow from './withShow';

type Props = {
  /** If true, confirm button cannot be clicked (no callback). */
  confirmDisabled?: boolean;
  /** Called when user clicks confirm button. */
  confirmOnClick?: () => void;
};

/**
 * Blocking modal. Temporary code while feature is being developed.
 */
export const PaintedDoor = ({ confirmOnClick = _.noop, confirmDisabled = false }: Props) => {
  const title = _t('Coming soon');

  return (
    // At time of writing modal does not allow pass through of additional properties. To allow selection of modal components
    // we wrap entire contents in `data-e2e` tag.
    <div data-e2e={PaintedDoor.e2eName}>
      <Modal
        className="rc-PaintedDoor"
        // This gets dropped into an `aria-label` on the modal. This should be translated and in plain language.
        modalName={title}
        allowClose
        handleClose={confirmOnClick}
      >
        <Typography className="title" variant="h1" component="h2">
          {title}
        </Typography>

        <p className="content">{_t('Feature is not yet complete.')}</p>

        <div className="footer">
          <Button
            disabled={confirmDisabled}
            onClick={confirmOnClick}
            data-e2e="btn-confirm"
            className="button"
            variant="primary"
          >
            {_t("Okay, fine, I'll wait.")}
          </Button>
        </div>
      </Modal>
    </div>
  );
};

PaintedDoor.e2eName = 'staff-management-painted-door';

export const storeConnector = ({ StaffManagementStoreV2 }: $TSFixMe, { executeAction }: $TSFixMe) => {
  const { show } = StaffManagementStoreV2.ui('paintedDoor');
  return {
    confirmOnClick: () => {
      return executeAction(actions.paintedDoor.show, false);
    },
    show,
  };
};

export default compose<Props, Props>(
  withFluxibleContextAsProps(),
  connectToStores<Props, Props & ActionContext>(['StaffManagementStoreV2'], storeConnector),
  withShow()
)(PaintedDoor);
